import { ReactNode } from "react";

type EstimatePageProps = {
  children: ReactNode;
  disclaimer: string;
};

export function EstimatePage({ children, disclaimer }: EstimatePageProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex-1">{children}</div>
      <footer className="mx-auto w-full max-w-3xl px-4 pb-5 pt-2 sm:px-6">
        <p className="border-t border-[var(--line)] pt-4 text-center text-[10px] leading-relaxed text-[var(--text-muted)] sm:text-[11px]">
          {disclaimer}
        </p>
      </footer>
    </div>
  );
}
